import { useState } from 'react';
import { LibraryVideo } from '../videos/videos.domain';
import { EditParams } from '../videos/videos.model';
import {
  MuxVideo,
  muxToBackendExerciseMedia,
  toLibraryVideo,
} from '../videos/videos.helpers';
import toast from 'react-hot-toast';
import { Media } from 'generated/graphql';
import { influencerMuxVideoUpload } from '../../LandingPagesBuilder/muxVideoUpload';

type State = {
  showDropZone: boolean;
  showEditMedia: boolean;
  media: File | null;
  uploadedFile: LibraryVideo | null;
  progress: number;
  step: Step;
  editParams: EditParams | undefined;
};

export type Step = 'validate' | 'thumbnail';

const initialState = {
  step: 'validate' as Step,
  showDropZone: false,
  showEditMedia: false,
  media: null,
  editParams: undefined,
  progress: 0,
  uploadedFile: null,
};

export const useExerciseUpload = ({
  influencerId,
  onChange,
  video,
  setUploadingMedia,
}: {
  influencerId: number;
  onChange: (media: Media | null) => void;
  setUploadingMedia: (value: boolean) => void;
  video?: Media;
}) => {
  const [state, setState] = useState<State>({
    ...initialState,
    uploadedFile: video ? toLibraryVideo('Media')(video) : null, // [G] TODO: fix it
  });

  const selectVideo = (file: File) => {
    setState({
      ...state,
      media: file,
      showDropZone: false,
      showEditMedia: true,
    });
  };
  const updateMedia = ({
    file,
    editParams,
  }: {
    file: File;
    editParams?: EditParams;
  }) =>
    setState({
      ...state,
      editParams: editParams,
      media: file,
      step: 'validate',
    });

  const setThumbnail = (time: number) =>
    setState({
      ...state,
      editParams: {
        ...state.editParams,
        thumbnailTimestamp: time,
      },
    });

  const cancelEdit = () => setState(initialState);

  const onValidationSuccess = () =>
    setState((prevState) => ({
      ...prevState,
      step: 'thumbnail',
    }));

  const toggleDropzone = () =>
    setState((prevState) => ({
      ...prevState,
      showDropZone: !prevState.showDropZone,
    }));

  const removeMedia = () => {
    setState(initialState);
    onChange(null);
  };

  const upload = async () => {
    if (!state.media) {
      toast.error('Video file is missing, please upload a file');
      return;
    }
    setUploadingMedia(true);
    const video: Omit<MuxVideo, 'influencerId'> =
      await influencerMuxVideoUpload(influencerId, state.media, {
        thumbnailPosition: state.editParams?.thumbnailTimestamp,
      });

    onChange(muxToBackendExerciseMedia({ ...video, influencerId }));
    setState((prevState) => ({
      ...prevState,
      uploadedFile: toLibraryVideo('MuxVideo')({ ...video, influencerId }),
    }));
    setUploadingMedia(false);
  };

  return {
    ...state,
    selectVideo,
    cancelEdit,
    toggleDropzone,
    upload,
    removeMedia,
    updateMedia,
    setThumbnail,
    onValidationSuccess,
  };
};
